import React from 'react';

import { AudioLevelIndicator } from '../../../audio-level-indicator';
import { Icon, IconMicrophoneEmptySlash } from '../../../base/icons';
import Tooltip from '../../../base/tooltip/components/Tooltip';
import { LAYOUTS } from '../../../video-layout';


type Props = {
    _filmStripView: string,
    raisedHand: boolean,
    participantDisplayName: string,
    _showAudioMutedIndicator: boolean,
    participant?: Object,
    audioLevel: number,
    _designation?: string,
    _organization?: string,
    t: Function,

    /**
     * Whether the participant in the large video is the local participant.
     * Click-to-mute is only available when this is true.
     */
    isLocal?: boolean,

    /**
     * Callback to toggle local audio mute. Only called when isLocal is true.
     */
    onToggleAudioMute?: Function,
};

/**
 * Returns the participant name for the large video
 */
const LargeVideoDisplayName = ({
    _filmStripView,
    raisedHand,
    participantDisplayName,
    _showAudioMutedIndicator,
    participant,
    audioLevel,
    _participantName,
    _designation,
    _organization,
    isLocal,
    onToggleAudioMute,
    t
}: Props) => {

    /**
     * Helper function (NOT a React component)
     */
    function renderAudioIndicator() {

        return _showAudioMutedIndicator ? (
            <Tooltip
                content = { t('tooltip.audioMutedTooltip') }
                position = 'top'>
                <div className = 'audio-level-mic-icon-largevideo'>
                    <Icon src = { IconMicrophoneEmptySlash } />
                </div>
            </Tooltip>
        ) : <AudioLevelIndicator audioLevel = { audioLevel } />;
    }

    /**
     * Handles click on the display name container.
     * Only fires the mute toggle when the participant is local.
     */
    function handleNameClick(event) {
        if (isLocal && onToggleAudioMute) {
            event.stopPropagation();
            onToggleAudioMute();
        }
    }

    const localClickProps = isLocal
        ? {
            onClick: handleNameClick,
            style: { cursor: 'pointer' },
            title: _showAudioMutedIndicator ? t('videothumbnail.unmute') : t('videothumbnail.mute')
        }
        : {};

    if (_filmStripView === LAYOUTS.TILE_VIEW) {
        return null;
    }

    if (participant?.isFakeParticipant) {
        return (
            <div className = 'largevideo-display-name-parent'>
                <div className = 'largevideo-display-name'>
                    {_participantName}
                </div>
            </div>
        );
    }

    if (participant?.name === 'YouTube') {

        return (
            <div className = 'largevideo-display-name-parent'>
                <div className = 'largevideo-display-name'>
                    {_participantName}
                </div>
            </div>
        );
    }

    if (raisedHand) {
        const name = participant?.local ? 'You' : participantDisplayName;

        return (
            <div className = 'largevideo-display-name-parent'>
                <div
                    className = 'largevideo-display-name'
                    { ...localClickProps }>
                    {`${t('notify.raisedHand', { name })} ✋` }
                    {renderAudioIndicator()}
                </div>

                {(_designation || _organization) && (
                    <div className = 'largevideo-display-name-info'>
                        {_designation && _designation}
                        {_organization && ` ( ${_organization} )`}
                    </div>
                )}
            </div>

        );
    }

    return (
        <div className = 'largevideo-display-name-parent'>
            <div
                className = 'largevideo-display-name'
                { ...localClickProps }>
                {participantDisplayName}
                {renderAudioIndicator()}
            </div>

            {(_designation || _organization) && (
                <div className = 'largevideo-display-name-info'>
                    {_designation && _designation}
                    {_organization && ` ( ${_organization} )`}
                </div>
            )}
        </div>
    );
};

export default LargeVideoDisplayName;
